import React from 'react';
import { motion } from 'framer-motion';
const scienceCards = [{
  icon: '📈',
  title: 'El Cortisol se descontrola',
  text: 'La hormona del estrés puede elevarse en la madrugada (alrededor de las 3 am), despertándote de golpe y manteniéndote alerta.'
}, {
  icon: '⚖️',
  title: 'Tus hormonas fluctúan',
  text: 'La caída de progesterona (la hormona relajante) y estrógeno afecta directamente tu capacidad para lograr un sueño profundo.'
}, {
  icon: '🌙',
  title: 'La Melatonina disminuye',
  text: 'Con la edad, producimos menos hormona del sueño. Necesitas nuevas estrategias de luz y rutinas para estimular su producción natural.'
}];
export function ScienceSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-221">
      <div className="max-w-6xl mx-auto" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-223">
          <span className="text-warm-accent font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-224">
            La verdad que nadie te dice
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-olive" data-id="element-225">
            ¿Por qué tu sueño cambia después de los 40?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-226">
          {scienceCards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-cream p-8 rounded-2xl text-center border border-sage/10 hover:border-sage/30 transition-colors" data-id="element-227">
              <div className="text-5xl mb-6" data-id="element-228">{card.icon}</div>
              <h3 className="text-xl font-bold text-olive mb-4 font-heading" data-id="element-229">
                {card.title}
              </h3>
              <p className="text-warm-gray leading-relaxed" data-id="element-230">{card.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-sage text-white p-8 md:p-10 rounded-2xl text-center max-w-4xl mx-auto shadow-lg" data-id="element-231">
          <p className="text-lg md:text-xl font-medium leading-relaxed" data-id="element-232">
            <span className="font-bold block mb-2 text-xl md:text-2xl" data-id="element-233">
              La buena noticia:
            </span>
            Una vez que entiendes estos cambios, puedes trabajar CON tu cuerpo,
            no contra él. Y eso es exactamente lo que te enseña esta guía.
          </p>
        </motion.div>
      </div>
    </section>;
}